import { XIcon } from 'lucide-react'
import type { FilterChip } from '@/lib/filters'

interface FilterChipsProps {
  chips: FilterChip[]
}

interface FilterChipItemProps {
  chip: FilterChip
}

function FilterChipItem({ chip }: FilterChipItemProps): React.ReactElement {
  return (
    <span className="inline-flex items-center gap-1 rounded-full border border-border bg-muted px-2.5 py-0.5 text-xs font-medium">
      {chip.label}
      <button
        type="button"
        aria-label={`Ta bort filtret ${chip.label}`}
        className="rounded-full text-muted-foreground hover:text-foreground"
        onClick={chip.onRemove}
      >
        <XIcon className="size-3" />
      </button>
    </span>
  )
}

export function FilterChips({ chips }: FilterChipsProps): React.ReactElement {
  return (
    <div className="flex flex-wrap gap-2">
      {chips.map((chip) => (
        <FilterChipItem
          key={chip.key}
          chip={chip}
        />
      ))}
    </div>
  )
}
